import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { WEBSITE_CONFIGURATION_ENDPOINTS } from 'src/app/core/api/endpoints/website-configuration.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

// Gallery Image Interface (matches API contract)
export interface GalleryImage {
  id: number;
  image: string;
  ordering: number;
}

export interface ReorderGalleryImage {
  id: number;
  ordering: number;
}

// Paginated Response Interface
export interface PaginatedGalleryResponse {
  count: number;
  links: {
    next: string | null;
    previous: string | null;
  };
  page: number;
  pages_count: number;
  results: GalleryImage[];
}

@Injectable({
  providedIn: 'root'
})
export class WebsiteConfigrationService {
  private api = inject(ApiService);

  getServiceOptions(): Observable<any> {
    return this.api.get<any>(WEBSITE_CONFIGURATION_ENDPOINTS.V1.WEBSITE_SERVICES_CONFIGURATION_OPTIONS);
  }

  getWebsiteConfigrationByServiceID(serviceId: string): Observable<any> {
    return this.api.get<any>(WEBSITE_CONFIGURATION_ENDPOINTS.V1.WEBSITE_SERVICES_CONFIGURATION(serviceId));
  }

  updateWebsiteConfigurationByServiceID(serviceId: string, data,
    withProgress = false, buttonId?: string): Observable<any> {

    let options: any = {};

    if (buttonId) {
      options.context = new HttpContext().set(BUTTON_LOADING_ID, buttonId);
    }

    if (withProgress) {
      options = {
        ...options,
        observe: 'events' as const,
        reportProgress: true
      };

      return this.api.put<any>(WEBSITE_CONFIGURATION_ENDPOINTS.V1.WEBSITE_SERVICES_CONFIGURATION(serviceId), data, options);
    }

    return this.api.put<any>(WEBSITE_CONFIGURATION_ENDPOINTS.V1.WEBSITE_SERVICES_CONFIGURATION(serviceId), data, options);
  }

  // Gallery Image APIs
 
  getGalleryImages(serviceId: string, page: number = 1): Observable<PaginatedGalleryResponse> {
    return this.api.get<PaginatedGalleryResponse>(
      WEBSITE_CONFIGURATION_ENDPOINTS.V1.GALLERY_IMAGES(serviceId),
      { params: { page: page.toString() } }
    );
  }

 
  addGalleryImage(serviceId: string, formData: FormData): Observable<GalleryImage> {
    return this.api.post<GalleryImage>(
      WEBSITE_CONFIGURATION_ENDPOINTS.V1.GALLERY_IMAGES(serviceId),
      formData
    );
  }


  deleteGalleryImage(serviceId: string, imageId: number): Observable<void> {
    return this.api.delete<void>(
      WEBSITE_CONFIGURATION_ENDPOINTS.V1.GALLERY_IMAGE_DETAIL(serviceId, imageId)
    );
  }

  reorderGalleryImages(serviceId: string, reorderData: ReorderGalleryImage[]): Observable<void> {
    return this.api.patch<void>(
      WEBSITE_CONFIGURATION_ENDPOINTS.V1.GALLERY_IMAGES_REORDER(serviceId),
      reorderData
    );
  }

  getSEODataByServiceID(serviceId: string): Observable<any> {
    return this.api.get<any>(WEBSITE_CONFIGURATION_ENDPOINTS.V1.SEO_DATA(serviceId));
  }

  updateSEODataByServiceID(serviceId: string, data, buttonId?: string): Observable<any> {
    let options: any = {};

    if (buttonId) {
      options.context = new HttpContext().set(BUTTON_LOADING_ID, buttonId);
    }

    return this.api.put<any>(WEBSITE_CONFIGURATION_ENDPOINTS.V1.SEO_DATA(serviceId), data, options);
  }
}
